import styled, { css } from 'styled-components'
import MaleIcon from '../../../assets/icons/male.svg'
import FemaleIcon from '../../../assets/icons/female.svg'
import AgencyIcon from '../../../assets/icons/agency.svg'

interface ImageProps {
    width?: string
    height?: string
    borderRadius?: string
    marginRight?: string
}

export const StyledImageContainer = styled.img<ImageProps>(
    ({ theme, width, height, borderRadius, marginRight }) => css`
        display: flex;
        flex-direction: row;
        margin-right: ${marginRight ?? theme.spacing.medium};
        border-radius: ${borderRadius ?? theme.typography.border.radius.small};
        height: ${height ?? theme.layout.xLarge};
        width: ${width ?? theme.layout.xLarge};
        aspect-ratio: unset;
    `,
)

export const StyledMaleIcon = styled(MaleIcon)<ImageProps>(
    ({ theme, width, height, borderRadius, marginRight }) => css`
        display: flex;
        flex-direction: row;
        margin-right: ${marginRight ?? theme.spacing.medium};
        border-radius: ${borderRadius ?? theme.typography.border.radius.small};
        height: ${height ?? theme.layout.xLarge};
        width: ${width ?? theme.layout.xLarge};
        aspect-ratio: 1 / 1;
    `,
)

export const StyledFemaleIcon = styled(FemaleIcon)<ImageProps>(
    ({ theme, width, height, borderRadius, marginRight }) => css`
        display: flex;
        flex-direction: row;
        margin-right: ${marginRight ?? theme.spacing.medium};
        border-radius: ${borderRadius ?? theme.typography.border.radius.small};
        height: ${height ?? theme.layout.xLarge};
        width: ${width ?? theme.layout.xLarge};
        aspect-ratio: 1 / 1;
    `,
)

export const StyledAgencyIcon = styled(AgencyIcon)<ImageProps>(
    ({ theme, width, height, borderRadius, marginRight }) => css`
        display: flex;
        flex-direction: row;
        margin-right: ${marginRight ?? theme.spacing.medium};
        border-radius: ${borderRadius ?? theme.typography.border.radius.small};
        height: ${height ?? theme.layout.xLarge};
        width: ${width ?? theme.layout.xLarge};
        aspect-ratio: 1 / 1;
    `,
)

export const OwnerInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
`

export const OwnerDetailItem = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    &:last-child {
        padding-bottom: 0;
    }
`

export const OwnerDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`
